var Tag;

Tag = function(self, options) {
  Selectable(self);
  Editable(self, 'name', (function(_this) {
    return function(new_name) {
      return self.update({
        name: new_name
      });
    };
  })(this));
  self.update = (function(_this) {
    return function(data, callback) {
      return api.tags.update(self.id, data).done(callback);
    };
  })(this);
  return self;
};

if (api.tags == null) {
  api.add('tags');
}

api.tags.add('tags');

Tag.find = function(asset_id, callback) {
  return api.assets.tags.read(asset_id).done(callback);
};

Tag.create = function(name, callback) {
  return api.tags.create({
    name: name
  }).done(callback);
};

Tag.subtags = function(tag_id, options, callback) {
  return api.tags.tags.read(tag_id, options).done(callback);
};

//# sourceMappingURL=tag.js.map
